export default "__VITE_ASSET__CgS1q0YG__"